import styles from "./PrimaryButton.module.scss";

const PrimaryButton = ({
  children,
  onClick,
  type = "button",
  className = "",
  disabled = false,
  fontSize,
  fontWeight,
  variant = "primary",
  selected,
  loading = false,
  style = {},
}) => {
  const handleClick = (e) => {
    if (loading || disabled) {
      e.preventDefault();
      return;
    }
    onClick?.(e);
  };

  return (
    <button
      type={type}
      className={`
        ${variant === "second" ? styles.secondPrimary : styles.primaryButton}
        ${styles[variant]}
        ${className}
        ${selected ? styles.active : ""}
        ${loading ? styles.loading : ""}
      `}
      style={{ fontSize, fontWeight, ...style }}
      onClick={handleClick}
      disabled={disabled || loading}
      aria-busy={loading ? "true" : "false"}
    >
      <span className={`${styles.content} ${loading ? styles.contentHidden : ""}`}>
        {children}
      </span>

      {loading && (
        <span className={styles.spinner} aria-label="Cargando" />
      )}
    </button>
  );
};

export default PrimaryButton;
